module.exports = __webpack_public_path__ + "img/32.c6489980.png";